// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2711":"adb823d1","3570":"adb823d1","6674":"0a8af966","7670":"ebd20c0c","9184":"adb823d1"}[chunkId] + ".chunk.css";
};